// src/layouts/Pages/PageHeader/CardHeaderTeamMembers.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import SimpleAvatarGroup from 'components/SimpleComponents/SimpleAvatarGroup';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const CardHeaderTeamMembers = ({ team }) => {
  if (!team || team.length === 0) return null;

  const items = team.map((member, i) => ({
    key: member?._id || i,
    src: getAvatarSrc(member),
    name: member?.name,
    backColor: member?.backColor,
    foreColor: member?.foreColor,
  }));

  return <SimpleAvatarGroup items={items} maxCount={3} size={24} />;
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default CardHeaderTeamMembers;

// *******************************************************************************
// HELPERS
// *******************************************************************************
function getAvatarSrc(member) {
  const avatar = member?.avatar;
  return avatar?.base64Thumb || avatar?.thumbUrl || avatar?.storageUrl || member?.img;
}
